import { ref, watch } from 'vue'

export default (store, ctx = {}) => {
  const start = ctx.start || 1
  const pendingStop = ctx.pending || 60
  const percentageReady = ref(start)
  const percentageInterval = setInterval(() => {
    if (percentageReady.value >= pendingStop) {
      clearInterval(percentageInterval)
      return
    }
    percentageReady.value += 1
  }, 60)

  const handleReady = ready => {
    if (ready) {
      clearInterval(percentageInterval)
      percentageReady.value = 99
      setTimeout(() => {
        percentageReady.value = 100
      }, 500)
    }
  }
  watch(() => store.getters.ready, handleReady)
  handleReady(store.getters.ready)

  return { percentageReady, ready: percentageReady.value === 0 }
}
